module.exports = __webpack_public_path__ + "img/avatar-1.7cd0b5a6.jpg";